<template>
    <div class="expert-panel">
        <main>
            <div class="expert-panel__header">
                <h1>Личный кабинет эксперта</h1>
                <div class="expert-panel__header-total">
                    <div>{{ totalEvents }}</div>
                    <div>{{ declinationOfNumber(totalEvents, 'мероприятие', 'мероприятия', 'мероприятий')}}</div>
                </div>
            </div>
            <div v-loading="loading">
                <ExpertPanelMain :items="dataset.items" />
            </div>
        </main>
    </div>
</template>

<script>
import ExpertPanelMain from "@/components/expert-panel-new/ExpertPanelMain.vue";
import {mapGetters} from "vuex";
import declinationOfNumber from "@/tools/declinationOfNumber";

export default {
    name: 'ExpertPanel',
    components: {
        ExpertPanelMain,
    },
    mounted() {
        document.body.style.background = '#fff';
    },
    beforeDestroy() {
        document.body.style.background = '#EDEEF0';
    },
    computed: {
        ...mapGetters('examination', ['getLoading', 'totalEvents']),
        dataset() {
            return this.$store.state.examination.events.review || {
                items: [],
            };
        },
        loading() {
            return this.getLoading('events') || false;
        },
    },
    methods: {
        declinationOfNumber(count, one, two, five) {
            return declinationOfNumber(count, one, two, five);
        },
    },
    async created() {
        await this.$store.dispatch('examination/loadEvents');
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';

.expert-panel {
  background: #fff;
  font-family: Montserrat, sans-serif;
  &__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: rem(16);
    border-bottom: solid 1px #000;
    &-total {
      display: flex;
      flex-direction: column;
      align-items: center;
      div:first-child {
        font-weight: 800;
        font-size: rem(56);
        line-height: rem(66);
      }
      div:last-child {
        font-weight: 400;
        font-size: rem(16);
        line-height: rem(18);
      }
    }
  }
  main {
    padding: rem(44) rem(156);
    h1 {
      margin: 0;
      font-weight: 700;
      font-size: rem(56);
      line-height: rem(66);
      color: #251F45;
    }
  }
}
h1 {
  margin: 0;
}
</style>
